import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_CAB_FAQ_DATA } from '../../../common/redux/action-types';
import { cabsFaqDataSelector } from '../../../common/redux/selector';
import { fetchCabsFaqData } from '../../../common/redux/thunks';
import { getLoadedComponent } from '../../../config/omni';
import FaqSection from '@React_UI_Lib/FaqSection'
import * as S from '../FaqPageStyles';

const FaqSectionComp = () => {
    const dispatch = useDispatch();
    const cabFaqData = useSelector(cabsFaqDataSelector)

    useEffect(() => {
      getLoadedComponent('FaqSectionComp')
      if(!cabFaqData?.length) fetchFaqData()
    }, [])

    const fetchFaqData = async () => {
      const faqData = await fetchCabsFaqData();
      if (faqData) {
        dispatch({
          type: UPDATE_CAB_FAQ_DATA,
          faqData: faqData
        });
      }
    }

    return (
      <>
        {cabFaqData?.length ? (
          <FaqSection
            faqs={cabFaqData}
            showTags={false}
            showSearchInput={true}
            containerStyles={{
              fontFamily: 'Rubik',
              padding: '12px 12px 16px 12px',
              backgroundColor : '#fff',
              borderRadius : '4px'
            }}
            titleStyles={{fontSize: 20, fontFamily:'Rubik'}}
            questionTextStyle={{fontFamily:'Rubik', fontSize: 16}}
            faqQnActiveStyle={{fontSize: 16, paddingRight: 10}}
            answerTextStyle={{fontFamily:'Rubik', fontSize: 14, paddingRight: 10}}
          />
        ) : null}
      </>
    );
}


export default FaqSectionComp;
